import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BsGraphUpArrow, BsBuilding, BsPeople, BsCalendar2Event } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { masterDashboard } from "../../../redux/actions/Admin.action";
import TotalLeadsChart from "components/charts/TotalLeadsChart";

export default function UserReports() {
  const counts = useSelector((state) => state.admin);
  const CountData = counts?.masterCount?.data;
  const dispatch = useDispatch();

  const getFile = useSelector((state) => state.files);
  const totalLeads = getFile?.getAllLead?.data?.totalCount || 0;

  useEffect(() => {
    dispatch(masterDashboard());
  }, []);

  return (
    <>
      <div className="mt-[100px]"></div>
      <Box pt={{ base: "20px", md: "40px", xl: "50px" }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
          gap='20px'
          mb='20px'
        >
          <Link to={"/master/lead"}>
            <MiniStatistics
              bgColor="linear-gradient(135deg, #cceaff, #e6f7ff)" // Soft Blue
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<BsGraphUpArrow className="text-[24px]" />}
                />
              }
              name='Total Lead'
              value={CountData?.leadsCount || 0}
            />
          </Link>

          <Link to={"/master/branch"}>
            <MiniStatistics
              bgColor="linear-gradient(135deg, #d5f5e3, #eafaf1)" // Light Green
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<BsBuilding className="text-[24px]" />}
                />
              }
              name='Total Branch'
              value={CountData?.branchCount || 0}
            />
          </Link>

          <Link to={"/master/adminUser"}>
            <MiniStatistics
              bgColor="linear-gradient(135deg, #fceabb, #f8d47e)" // Light Gold
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<BsPeople className="text-[24px]" />}
                />
              }
              name='Total Counsellor'
              value={CountData?.doctorCount || 0}
            />
          </Link>

          <Link to={"/master/birthdays"}>
            <MiniStatistics
              bgColor="linear-gradient(135deg, #ffd6e0, #ffe8ec)" // Light Pink
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<BsCalendar2Event className="text-[24px]" />}
                />
              }
              name="Today's Birthdays"
              value={CountData?.todayBirthdayCount || 0}
            />
          </Link>
        </SimpleGrid>
      </Box>
      <Box>
        <TotalLeadsChart />
      </Box>
    </>
  );
}
